import React from 'react';

export const ShutterCenterFold = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 113.2 52.9"
      width="136"
      {...props}
    >
      <path fill="#fff" d="M3.5.5h106.2v45.9H3.5z" />
      <path
        d="M109.7 46.9H3.5c-.3 0-.5-.2-.5-.5V.5c0-.3.2-.5.5-.5h106.2c.3 0 .5.2.5.5v45.9c0 .3-.2.5-.5.5zM4 45.9h105.3V1.1H4v44.8z"
        fill="#dcd9d5"
      />
      <path fill="#fff" d="M3.5.5h106.2v45.9H3.5z" />
      <path
        d="M109.7 46.9H3.5c-.3 0-.5-.2-.5-.5V.5c0-.3.2-.5.5-.5h106.2c.3 0 .5.2.5.5v45.9c0 .3-.2.5-.5.5zM4 45.9h105.3V1.1H4v44.8z"
        fill="#dcd9d5"
      />
      <g fill="#dcd9d5">
        <path d="M6.3 3.6h100.6v39.8H6.3z" />
        <path d="M106.9 43.9H6.3c-.3 0-.5-.2-.5-.5V3.6c0-.3.2-.6.5-.6h100.6c.3 0 .5.2.5.5v39.8c0 .4-.2.6-.5.6zM6.8 42.8h99.6V4.1H6.8v38.7z" />
      </g>
      <path
        d="M112.8 46.9H.5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h112.3c.3 0 .5.2.5.5-.1.3-.3.5-.5.5z"
        fill="#dcd9d5"
      />
      <g>
        <path fill="#233762" d="M4 1.1l24.5 5.7.1 45.2L4 45.8z" />
        <path
          d="M29.1 52.6L3.6 46.3V.5L29 6.4l.1 46.2zM4.4 45.4l23.7 5.9-.1-44L4.4 1.8v43.6z"
          fill="#fff"
        />
        <path fill="#233762" d="M6.6 6.4L26 11l.1 3.2L6.6 9.7z" />
        <path
          d="M26.3 14.6L6.4 9.9V6.1l19.9 4.7v3.8zM6.8 9.4l19 4.5v-2.6l-19-4.5v2.6z"
          fill="#fff"
        />
        <path fill="#233762" d="M6.6 9.7l19.5 4.5v3.3L6.6 12.9z" />
        <path
          d="M26.3 17.8L6.4 13.1V9.3L26.3 14v3.8zM6.8 12.6l19 4.5v-2.6L6.8 10v2.6z"
          fill="#fff"
        />
        <path fill="#233762" d="M6.6 12.9l19.5 4.6v3.2L6.6 16.1z" />
        <path
          d="M26.3 21.1L6.4 16.3v-3.8l19.9 4.7v3.9zM6.8 15.8l19 4.5v-2.7l-19-4.5v2.7z"
          fill="#fff"
        />
        <path fill="#233762" d="M6.6 16.1l19.5 4.6V24L6.6 19.3z" />
        <path
          d="M26.3 24.3L6.4 19.6v-3.8l19.9 4.7v3.8zM6.8 19.1l19 4.5v-2.7l-19-4.5v2.7z"
          fill="#fff"
        />
        <path fill="#233762" d="M6.6 19.3L26.1 24v3.2L6.6 22.5z" />
        <path
          d="M26.3 27.6L6.4 22.8V19l19.9 4.8v3.8zM6.8 22.3l19 4.6v-2.7l-19-4.6v2.7z"
          fill="#fff"
        />
        <path fill="#233762" d="M6.6 22.5l19.5 4.7v3.3L6.6 25.8z" />
        <path
          d="M26.3 30.8L6.4 26v-3.8L26.3 27v3.8zM6.8 25.5l19 4.6v-2.7l-19-4.6v2.7z"
          fill="#fff"
        />
        <g>
          <path fill="#233762" d="M6.6 25.8l19.5 4.7v3.2L6.6 29z" />
          <path
            d="M26.3 34.1L6.4 29.2v-3.8l19.9 4.8v3.9zM6.8 28.7l19 4.6v-2.7L6.8 26v2.7z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M6.6 29l19.5 4.7V37L6.6 32.2z" />
          <path
            d="M26.3 37.3l-20-4.9v-3.8l19.9 4.8.1 3.9zM6.8 32l19 4.6v-2.7l-19-4.6V32z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M6.6 32.2L26.1 37v3.2L6.6 35.4z" />
          <path
            d="M26.3 40.6l-20-4.9v-3.8l20 4.9v3.8zM6.8 35.2l19.1 4.7v-2.7l-19-4.7-.1 2.7z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M6.6 35.4l19.5 4.8v3.3L6.6 38.7z" />
          <path
            d="M26.3 43.8l-20-4.9v-3.8l20 4.9v3.8zM6.8 38.4l19.1 4.7v-2.7L6.8 35.8v2.6z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M6.6 38.7l19.5 4.8v3.2L6.6 41.9z" />
          <path
            d="M26.4 47.1l-20-5v-3.8l20 4.9v3.9zM6.8 41.7l19.1 4.7v-2.7L6.8 39v2.7z"
            fill="#fff"
          />
        </g>
        <path fill="#fff" d="M15.7 8.6l1.3.3v35.6l-1.2-.3z" />
      </g>
      <g>
        <path fill="#233762" d="M29.5 6.6l25.1-5.5v44.7L29.5 52z" />
        <path
          d="M55 46.3l-26 6.4V6.1L55 .5v45.8zm-25 5l24.2-5.9V1.8L30 7v44.3z"
          fill="#fff"
        />
        <path fill="#233762" d="M32.2 10.8l19.9-4.4v3.2L32.2 14z" />
        <path
          d="M52.4 9.9L32 14.4v-3.9L52.4 6v3.9zm-19.9 3.8l19.4-4.3V6.7L32.5 11v2.7z"
          fill="#fff"
        />
        <path fill="#233762" d="M32.2 14l19.9-4.4v3.2l-19.9 4.5z" />
        <path
          d="M52.4 13.1L32 17.6v-3.9l20.4-4.5v3.9zm-19.9 3.8l19.4-4.3V10l-19.4 4.3v2.6z"
          fill="#fff"
        />
        <path fill="#233762" d="M32.2 17.3l19.9-4.5v3.3l-19.9 4.5z" />
        <path
          d="M52.4 16.3L32 20.9V17l20.4-4.6v3.9zm-19.9 3.9l19.4-4.4v-2.6l-19.4 4.4v2.6z"
          fill="#fff"
        />
        <path fill="#233762" d="M32.2 20.6l19.9-4.5v3.2l-19.9 4.5z" />
        <path
          d="M52.4 19.5L32 24.2v-3.9l20.4-4.6v3.8zm-19.9 4l19.4-4.4v-2.6l-19.4 4.4v2.6z"
          fill="#fff"
        />
        <path fill="#233762" d="M32.2 23.8l19.9-4.5v3.2l-19.9 4.6z" />
        <path
          d="M52.4 22.8L32 27.5v-3.9L52.4 19v3.8zm-19.9 4l19.4-4.5v-2.6l-19.4 4.4v2.7z"
          fill="#fff"
        />
        <path fill="#233762" d="M32.2 27.1l19.9-4.6v3.2l-19.9 4.7z" />
        <path
          d="M52.4 26L32 30.7v-3.9l20.4-4.7V26zm-19.9 4l19.4-4.5v-2.6l-19.4 4.5V30z"
          fill="#fff"
        />
        <g>
          <path fill="#233762" d="M32.2 30.4l19.9-4.7V29l-19.9 4.6z" />
          <path
            d="M52.4 29.2L32 34v-3.9l20.4-4.7v3.8zm-19.9 4.1l19.4-4.5v-2.6l-19.4 4.5v2.6z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M32.2 33.6L52.1 29v3.2l-19.9 4.7z" />
          <path
            d="M52.4 32.4L32 37.2v-3.9l20.4-4.8v3.9zm-19.9 4.1L51.9 32v-2.6L32.5 34v2.5z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M32.2 36.9l19.9-4.7v3.2l-19.9 4.7z" />
          <path
            d="M52.4 35.6L32 40.5v-3.9l20.4-4.8v3.8zm-19.9 4.2l19.4-4.6v-2.6l-19.4 4.6v2.6z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M32.2 40.2l19.9-4.8v3.3l-19.9 4.7z" />
          <path
            d="M52.4 38.9L32 43.8v-3.9l20.4-4.8v3.8zm-19.9 4.2l19.4-4.7v-2.6l-19.4 4.6v2.7z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M32.2 43.4l19.9-4.7v3.2l-19.9 4.8z" />
          <path
            d="M52.4 42.1L32 47v-3.9l20.4-4.9v3.9zm-19.9 4.2l19.4-4.7V39l-19.4 4.7v2.6z"
            fill="#fff"
          />
        </g>
        <path fill="#fff" d="M41.7 8.7l1.3-.3v35.7l-1.3.3z" />
      </g>
      <g>
        <path fill="#233762" d="M58.8 1.4l24.5 5.7.1 45.1L58.8 46z" />
        <path
          d="M83.8 52.9l-25.5-6.4V.7l25.4 5.9.1 46.3zm-24.6-7.3l23.7 5.9-.1-44L59.2 2v43.6z"
          fill="#fff"
        />
        <path fill="#233762" d="M61.4 6.7l19.4 4.5v3.3L61.4 9.9z" />
        <path
          d="M81 14.8l-19.9-4.7V6.3L81 11v3.8zM61.6 9.7l19 4.5v-2.6L61.6 7v2.7z"
          fill="#fff"
        />
        <path fill="#233762" d="M61.4 9.9l19.4 4.6v3.2l-19.4-4.6z" />
        <path
          d="M81 18.1l-19.9-4.7V9.6L81 14.2v3.9zm-19.4-5.2l19 4.5v-2.6l-19-4.5v2.6z"
          fill="#fff"
        />
        <path fill="#233762" d="M61.4 13.1l19.4 4.6v3.2l-19.4-4.6z" />
        <path
          d="M81.1 21.3l-19.9-4.7v-3.8L81 17.5l.1 3.8zm-19.5-5.2l19 4.5v-2.7l-19-4.5v2.7z"
          fill="#fff"
        />
        <path fill="#233762" d="M61.4 16.3L80.8 21v3.2l-19.4-4.6z" />
        <path
          d="M81.1 24.6l-19.9-4.8V16l19.9 4.7v3.9zm-19.5-5.3l19 4.5v-2.7l-19-4.5v2.7z"
          fill="#fff"
        />
        <path fill="#233762" d="M61.4 19.6l19.4 4.6v3.3l-19.4-4.7z" />
        <path
          d="M81.1 27.8l-20-4.8v-3.8l20 4.8v3.8zm-19.5-5.3l19 4.6v-2.7l-19-4.6v2.7z"
          fill="#fff"
        />
        <path fill="#233762" d="M61.4 22.8l19.4 4.7v3.2L61.4 26z" />
        <path
          d="M81.1 31l-19.9-4.8v-3.8l19.9 4.8V31zm-19.5-5.2l19 4.6v-2.7l-19-4.6v2.7z"
          fill="#fff"
        />
        <g>
          <path fill="#233762" d="M61.4 26l19.4 4.7.1 3.2-19.5-4.7z" />
          <path
            d="M81.1 34.3l-19.9-4.8v-3.8l19.9 4.8v3.8zM61.6 29l19 4.6v-2.7l-19-4.6V29z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M61.4 29.2l19.5 4.7v3.3l-19.5-4.8z" />
          <path
            d="M81.1 37.5l-20-4.9v-3.8L81 33.6l.1 3.9zm-19.5-5.3l19 4.6v-2.7l-19-4.6v2.7z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M61.4 32.4l19.5 4.8v3.2l-19.5-4.7z" />
          <path
            d="M81.1 40.8l-20-4.9v-3.8l20 4.9v3.8zm-19.5-5.4l19.1 4.7v-2.7l-19-4.7-.1 2.7z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M61.4 35.7l19.5 4.8v3.2l-19.5-4.8z" />
          <path
            d="M81.1 44.1l-20-4.9v-3.8l20 4.9v3.8zm-19.5-5.4l19.1 4.7v-2.7L61.6 36v2.7z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M61.4 38.9l19.5 4.8V47l-19.5-4.9z" />
          <path
            d="M81.1 47.3l-20-5v-3.8l20 4.9v3.9zm-19.5-5.4l19.1 4.7v-2.7l-19.1-4.7v2.7z"
            fill="#fff"
          />
        </g>
        <path fill="#fff" d="M70.5 8.8l1.3.3v35.6l-1.3-.3z" />
      </g>
      <g>
        <path fill="#233762" d="M84.3 6.8l25.1-5.4V46l-25.1 6.2z" />
        <path
          d="M109.8 46.5l-26 6.4V6.3l26-5.6v45.8zm-25.1 5l24.2-5.9V2L84.7 7.3v44.2z"
          fill="#fff"
        />
        <path fill="#233762" d="M87 11l19.9-4.4v3.3L87 14.3z" />
        <path
          d="M107.1 10.1l-20.4 4.5v-3.9l20.4-4.5v3.9zm-19.9 3.8l19.4-4.3V7l-19.4 4.3v2.6z"
          fill="#fff"
        />
        <path fill="#233762" d="M87 14.3l19.9-4.4v3.2L87 17.5z" />
        <path
          d="M107.1 13.3l-20.4 4.6V14l20.4-4.5v3.8zm-19.9 3.9l19.4-4.3v-2.6l-19.4 4.3v2.6z"
          fill="#fff"
        />
        <path fill="#233762" d="M87 17.5l19.9-4.4v3.2L87 20.8z" />
        <path
          d="M107.1 16.5l-20.4 4.6v-3.9l20.4-4.6v3.9zm-19.9 3.9l19.4-4.4v-2.6l-19.4 4.4v2.6z"
          fill="#fff"
        />
        <path fill="#233762" d="M87 20.8l19.9-4.5v3.2L87 24.1z" />
        <path
          d="M107.1 19.8l-20.4 4.6v-3.9l20.4-4.6v3.9zm-19.9 3.9l19.4-4.4v-2.6l-19.4 4.4v2.6z"
          fill="#fff"
        />
        <path fill="#233762" d="M87 24.1l19.9-4.6v3.3L87 27.3z" />
        <path
          d="M107.1 23l-20.4 4.7v-3.9l20.4-4.6V23zm-19.9 4l19.4-4.5v-2.6l-19.4 4.4V27z"
          fill="#fff"
        />
        <path fill="#233762" d="M87 27.3l19.9-4.5V26L87 30.6z" />
        <path
          d="M107.1 26.2l-20.4 4.7V27l20.4-4.7v3.9zm-19.9 4l19.4-4.5v-2.6l-19.4 4.5v2.6z"
          fill="#fff"
        />
        <g>
          <path fill="#233762" d="M87 30.6l19.9-4.6v3.2L87 33.9z" />
          <path
            d="M107.1 29.4l-20.4 4.8v-3.9l20.4-4.7v3.8zm-19.9 4.1l19.4-4.5v-2.6l-19.4 4.5v2.6z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M87 33.9l19.9-4.7v3.2L87 37.1z" />
          <path
            d="M107.1 32.7l-20.4 4.8v-3.9l20.4-4.8v3.9zm-19.9 4.1l19.4-4.6v-2.6l-19.4 4.6v2.6z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M87 37.1l19.9-4.7v3.2L87 40.4z" />
          <path
            d="M107.1 35.9l-20.4 4.8v-3.9l20.4-4.8v3.9zM87.2 40l19.4-4.6v-2.6l-19.4 4.6V40z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M87 40.4l19.9-4.7v3.2L87 43.7z" />
          <path
            d="M107.1 39.1L86.8 44v-3.9l20.4-4.8-.1 3.8zm-19.9 4.2l19.4-4.7V36l-19.4 4.6v2.7z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M87 43.7l19.9-4.8v3.2L87 46.9z" />
          <path
            d="M107.1 42.3l-20.4 4.9v-3.9l20.4-4.9v3.9zm-19.9 4.3l19.4-4.7v-2.6L87.2 44v2.6z"
            fill="#fff"
          />
        </g>
        <path fill="#fff" d="M96.4 8.9l1.3-.3v35.7l-1.3.3z" />
      </g>
    </svg>
  );
};
